import { reduxForm, change } from 'redux-form'
import { Autosuggest } from '../../components/common'
import { getStudentsFromOrg } from '../../actions/typeaheads'
import { getPreviousEducationPeriodCd } from '../../selectors/settings'
import {
  STUDENT_SEARCH_FORM_NAME,
  STUDENT_SEARCH_FIELD_NAME,
  STUDENT_SEARCH_FIELD_ID,
} from '../../constants/RefundExamConstants'

const checkStudentSelected = (val, allValues) =>
  Boolean(allValues[STUDENT_SEARCH_FIELD_ID])
    ? undefined
    : 'Error: You must select a student from the dropdown.'

const StudentFromOrgSearchForm = ({ orgId, educationPeriodCd, change }) => (
  <form onSubmit={e => e.preventDefault()}>
    <label htmlFor={STUDENT_SEARCH_FIELD_NAME}>
      Search for students whose fee(s) needs to be removed.
    </label>
    <Autosuggest
      formGroupStyles={{ marginBottom: 0 }}
      placeholder="Enter student name or AP ID"
      isRequired={true}
      name={STUDENT_SEARCH_FIELD_NAME}
      fetchSuggestions={val =>
        getStudentsFromOrg({
          orgId,
          educationPeriodCd,
          suggestion: val,
        })
      }
      renderSuggestion={s => (
        <div>
          <div>{`${s.lastName}, ${s.firstName} (${s.studentId})`}</div>
        </div>
      )}
      onChangeAction={() => change(STUDENT_SEARCH_FIELD_ID, null)}
      selectSuggestion={val => {
        change(STUDENT_SEARCH_FIELD_NAME, `${val.lastName}, ${val.firstName} (${val.studentId})`)
        change(STUDENT_SEARCH_FIELD_ID, val.studentId)
      }}
      validate={[checkStudentSelected]}
    />
  </form>
)

const mapStateToProps = (state, ownProps) => {
  const { orgId } = ownProps
  const educationPeriodCd = getPreviousEducationPeriodCd(state)
  return {
    orgId,
    educationPeriodCd,
  }
}

export default connect(
  mapStateToProps,
  { change }
)(
  reduxForm({
    form: STUDENT_SEARCH_FORM_NAME,
    initialValues: {
      [STUDENT_SEARCH_FIELD_NAME]: null,
      [STUDENT_SEARCH_FIELD_ID]: null,
    },
  })(StudentFromOrgSearchForm)
)
